import { Point } from 'geojson';

export type LatLngPair = {
  latitude: number | null;
  longitude: number | null;
};

export const geoPointToLatLng = (
  point: Point | null | undefined,
): LatLngPair => {
  const coords = point?.coordinates;
  if (!Array.isArray(coords) || coords.length !== 2) {
    return { latitude: null, longitude: null };
  }
  const [lng, lat] = coords;
  if (
    typeof lat !== 'number' ||
    typeof lng !== 'number' ||
    !Number.isFinite(lat) ||
    !Number.isFinite(lng)
  ) {
    return { latitude: null, longitude: null };
  }
  return { latitude: lat, longitude: lng };
};
